/** @jsx jsx */

import { Grid, Text } from '@zapier/design-system';
import { jsx, css } from '@emotion/core';

import Link from 'app/common/components/Link';
import LinkWithArrow from 'app/developer-v3/components/LinkWithArrow';
import ManagerLayout from 'app/developer-v3/layouts/ManagerLayout';
import { BASE_DOC_URL_VB } from 'app/developer-v3/constants';

const Styles = {
  advantages: css`
    list-style: disc inside;
    margin-bottom: 0px;
  `,
};

function Export() {
  return (
    <ManagerLayout title="Export Project to Zapier CLI">
      <Grid columns={1} gap="20px">
        <Text>
          The Zapier CLI (Command Line Interface) is a toolset you install and
          run on your local development environment. It allows you to build,
          test, and manage your Zapier integration through code and command line
          commands. Moving from the visual builder to the CLI tool brings a
          couple of advantages:
        </Text>
        <ul css={Styles.advantages}>
          <li>
            <Text>
              Access to{' '}
              <Link
                href={`${BASE_DOC_URL_VB}/quickstart/zapier-platform`}
                target="_blank"
              >
                every feature
              </Link>{' '}
              of the Zapier Platform
            </Text>
          </li>
          <li>
            <Text>Ability to better optimize your code</Text>
          </li>
          <li>
            <Text>Easier team collaboration</Text>
          </li>
          <li>
            <Text>Automated regression testing tools, and more</Text>
          </li>
        </ul>
        <Text>
          To try it out, you’ll install the Zapier CLI and run a command that
          creates a local version of your project. This will not change the
          existing work you've done in the visual builder, so feel free to
          explore. Note that versions built with the CLI can't be edited in the
          UI.
        </Text>
        <Text fontWeight={600}>
          <LinkWithArrow href={`${BASE_DOC_URL_VB}/manage/export-cli`}>
            How to export your integration
          </LinkWithArrow>
        </Text>
      </Grid>
    </ManagerLayout>
  );
}

export default Export;
